var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"add-to-calendar-button"},[_c('button',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.clickOutside),expression:"clickOutside"}],class:{
            btn: true,
            'btn-secondary': !_vm.dark && !_vm.green,
            'btn-success': _vm.green,
            outline: _vm.outline,
            'w-100': true,
            open: _vm.open,
            dark: _vm.dark,
            large: _vm.large,
            uppercase: _vm.uppercase,
        },attrs:{"id":"add-to-calendar-button"},on:{"click":_vm.toggle}},[_vm._v("\n        "+_vm._s(_vm.$t('vfair.events.addToCalendar'))+"\n\n        "),(_vm.open)?_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.googleLink,"rel":"nofollow","target":"_blank"}},[_vm._v("Google Calendar")])]),_c('li',[_c('a',{attrs:{"href":_vm.appleLink,"rel":"nofollow"}},[_vm._v("iCal (Apple)")])]),_c('li',[_c('a',{attrs:{"href":_vm.outlookLink,"rel":"nofollow"}},[_vm._v("Outlook")])]),_c('li',[_c('a',{attrs:{"href":_vm.yahooLink,"rel":"nofollow","target":"_blank"}},[_vm._v("Yahoo Calendar")])])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }